interface GuideSectionCardProps {
  icon: string;
  title: string;
  items: string[];
  accent?: string;
}

const GuideSectionCard = ({ icon, title, items, accent = "bg-primary" }: GuideSectionCardProps) => (
  <div className="bg-card rounded-xl p-3 shadow-card">
    <h3 className="text-xs font-semibold mb-2 flex items-center gap-1.5">
      <span>{icon}</span> {title}
    </h3>
    <ul className="space-y-1">
      {items.map((item, i) => (
        <li key={i} className="flex items-start gap-2 text-xs text-muted-foreground leading-snug">
          <span className={`w-1.5 h-1.5 ${accent} rounded-full flex-shrink-0 mt-1`} />
          {item}
        </li>
      ))}
    </ul>
  </div>
);

export default GuideSectionCard;
